/* eslint-disable import/prefer-default-export */

import {
  CREATE_LEAD_FAILURE,
  CREATE_LEAD_REQUEST,
  CREATE_LEAD_SUCCESS,
  SAVE_LEAD_SECRET_TOKEN,
  CREATE_LEAD_ERROR
} from "../constants/officeRunnerConstants";

export const createLeadRequest = () => ({ type: CREATE_LEAD_REQUEST });

export const createLeadSuccess = lead => ({ type: CREATE_LEAD_SUCCESS, lead });

export const createLeadFailure = error => ({
  type: CREATE_LEAD_FAILURE,
  error
});

export const createLeadError = error => ({ type: CREATE_LEAD_ERROR, error });

export const createLead = lead => async (dispatch, getState) => {
  const { address, utm } = getState();
  const params = Object.assign({}, lead, address, utm);

  dispatch(createLeadRequest());

  const response = await fetch(`${process.env.REACT_APP_CE_API_ROOT}/leads`, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_API_KEY
    },
    body: JSON.stringify(params)
  });

  if (!response.ok) {
    if (response.status === 422) {
      //sent an error back for us to display
      const json = await response.json();
      dispatch(createLeadError(json.Error));
    }
  } else {
    dispatch(createLeadSuccess(params));
  }
};

export const saveLeadSecretToken = token => ({
  type: SAVE_LEAD_SECRET_TOKEN,
  token
});



// WEBPACK FOOTER //
// ./src/actions/leadActionCreators.js